/**
 * Strip HTML tags and decode common HTML entities, returning plain text.
 * Splits on '<' and drops each segment up to the next '>' so the content
 * is never re-parsed as HTML. Unclosed tags (no matching '>') are dropped in full.
 */
export const stripHtmlToText = (text: string): string => {
	const stripped = text
		.split('<')
		.map((segment, i) => {
			if (i === 0) return segment
			const closeIdx = segment.indexOf('>')
			return closeIdx === -1 ? '' : ` ${segment.slice(closeIdx + 1)}`
		})
		.join('')

	const entities: [string, string][] = [
		['&nbsp;', ' '],
		['&lt;', '<'],
		['&gt;', '>'],
		['&quot;', '"'],
		['&#39;', "'"],
		['&amp;', '&'],
	]
	return entities.reduce((acc, [entity, char]) => acc.replaceAll(entity, char), stripped).trim()
}

/**
 * Count words in a string, stripping HTML first so that rich-text content
 * (as emitted by TipTap via TextStyleKit color spans, bold, etc.) is counted
 * the same way the live editor counter does — on plain text only.
 */
export const countWords = (text: string): number => {
	const plainText = stripHtmlToText(text)
	return plainText === '' ? 0 : plainText.split(/\s+/).length
}
